import { getToken } from "../../../shared/utils/common";


export class CommandDeleteFolder{
    async run(organizationId: number, folderId:number) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/folders/${folderId}/`
            try {
                const response = await fetch(url, {
                    method: "DELETE",
                    headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
